import { useState, useEffect, ReactNode } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Phone, MessageCircle, Menu, X, MapPin, ChevronDown } from "lucide-react";
import CookieBanner from "@/components/landing/CookieBanner";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
interface LayoutProps {
  children: ReactNode;
}
const Layout = ({
  children
}: LayoutProps) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();


  const whatsappNumber = "905326369115";
  const phoneNumber = "05326369115";
  const whatsappMessage = encodeURIComponent("Merhaba, Google Ads reklam yönetimi hizmeti hakkında bilgi almak istiyorum.");
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Hash'e göre scroll yap (ana sayfaya geldiğinde) - Retry mekanizması ile
  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      const id = location.hash.replace("#", "");

      // Birden fazla deneme yap (DOM yüklenme garantisi)
      const scrollAttempt = (attempts = 0) => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        } else if (attempts < 5) {
          // Element henüz yüklenmemişse, 200ms sonra tekrar dene
          setTimeout(() => scrollAttempt(attempts + 1), 200);
        }
      };

      // İlk deneme 100ms sonra (sayfa render olsun diye)
      setTimeout(() => scrollAttempt(), 100);
    }
  }, [location]);

  // Ana sayfaya git (SPA navigation)
  const goToHome = () => {
    setMobileMenuOpen(false);
    if (location.pathname === "/") {
      // Zaten ana sayfadaysak, en üste scroll yap
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    } else {
      // Başka sayfadaysak, navigate ile git
      navigate("/");
    }
  };

  // Bölüme scroll yap (alt sayfalardaysa önce ana sayfaya git)
  const scrollToSection = (id: string) => {
    setMobileMenuOpen(false);
    if (location.pathname !== "/") {
      // Alt sayfadaysak, ana sayfaya git ve hash ekle
      navigate(`/#${id}`);
      // Navigate sonrası scroll otomatik olacak (useEffect sayesinde)
    } else {
      // Ana sayfadaysak, direkt scroll yap (setTimeout ile DOM hazır olsun)
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      }, 100);
    }
  };
  return <div className="relative">

      {/* Tam ekran overlay - menü açıkken (mobile + tablet) */}
      {mobileMenuOpen && <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-[95] lg:hidden" onClick={() => setMobileMenuOpen(false)} />}
      
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 transition-all duration-300 border-b-2 ${isScrolled ? "bg-white backdrop-blur-lg shadow-2xl py-2 border-gray-200" : "bg-white/95 backdrop-blur-md shadow-lg py-3 border-gray-100"} ${mobileMenuOpen ? "z-[110]" : "z-[100]"}`} style={{
      willChange: 'transform'
    }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <button onClick={goToHome} className="flex items-center hover:opacity-80 transition-opacity">
              <img src="/images/logo-luxury-corporate.webp" alt="Reklam Uzmanı - Google Ads Uzmanı Logo" width="240" height="80" className="h-16 md:h-20 w-auto object-contain" fetchPriority="high" decoding="async" />
            </button>

            {/* Desktop Navigation - Dropdown ile */}
            <nav className="hidden lg:flex items-center gap-5">
              <button onClick={goToHome} className="text-gray-900 hover:text-[#059669] transition-all font-bold drop-shadow-sm hover:scale-105">
                Ana Sayfa
              </button>

              {/* Dropdown: Hizmetler */}
              <DropdownMenu>
                <DropdownMenuTrigger className="flex items-center gap-1 text-gray-900 hover:text-[#059669] transition-all font-bold drop-shadow-sm hover:scale-105">
                  Hizmetler
                  <ChevronDown className="w-4 h-4" />
                </DropdownMenuTrigger>
                <DropdownMenuContent className="bg-white border shadow-xl z-[110] min-w-[240px]">
                  <DropdownMenuItem onClick={() => scrollToSection("google-partner")} className="cursor-pointer hover:bg-gray-100 py-3 px-4">
                    <span className="font-semibold">🏆 Google Partner</span>
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => scrollToSection("sahte-tiklama")} className="cursor-pointer hover:bg-gray-100 py-3 px-4">
                    <span className="font-semibold">🛡️ Sahte Tıklama Koruması</span>
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => scrollToSection("paketler")} className="cursor-pointer hover:bg-gray-100 py-3 px-4">
                    <span className="font-semibold">📦 Paketler</span>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>

              <button onClick={() => scrollToSection("yorumlar")} className="text-gray-900 hover:text-[#059669] transition-all font-bold drop-shadow-sm hover:scale-105">
                Yorumlar
              </button>

              <button onClick={() => scrollToSection("sss")} className="text-gray-900 hover:text-[#059669] transition-all font-bold drop-shadow-sm hover:scale-105">
                SSS
              </button>

              <Link to="/hakkimda" className="text-gray-900 hover:text-[#059669] transition-all font-bold drop-shadow-sm hover:scale-105">
                Hakkımda
              </Link>

              <Link to="/blog" className="text-gray-900 hover:text-[#059669] transition-all font-bold drop-shadow-sm hover:scale-105">
                Blog
              </Link>

              <button onClick={() => scrollToSection("iletisim")} className="text-gray-900 hover:text-[#059669] transition-all font-bold drop-shadow-sm hover:scale-105">
                İletişim
              </button>
            </nav>

            {/* Desktop CTA Buttons - Biraz daha boşluklu */}
            <div className="hidden lg:flex items-center gap-4">
              <a href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-5 py-2.5 bg-[#25D366] text-white rounded-lg font-medium text-sm glow-green hover:scale-105 transition-transform" onClick={() => {
              if ((window as any).dataLayer) {
                (window as any).dataLayer.push({
                  event: "cta_whatsapp_click",
                  section: "header"
                });
              }
            }}>
                <MessageCircle className="w-4 h-4" />
                WhatsApp
              </a>
              <a href={`tel:${phoneNumber}`} className="flex items-center gap-2 px-5 py-2.5 bg-red-600 text-white rounded-lg font-medium text-sm glow-red hover:scale-105 transition-transform" onClick={() => {
              if ((window as any).dataLayer) {
                (window as any).dataLayer.push({
                  event: "cta_call_click",
                  section: "header"
                });
              }
            }}>
                <Phone className="w-4 h-4" />
                Hemen Ara
              </a>
            </div>

            {/* Mobile + Tablet Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden">
              {mobileMenuOpen ? <X className="w-6 h-6 text-gray-900" strokeWidth={2.5} /> : <Menu className="w-6 h-6 text-gray-900" strokeWidth={2.5} />}
            </button>
          </div>

          {/* Mobile + Tablet Menu */}
          {mobileMenuOpen && <>
              <div className="lg:hidden mt-4 pb-4 space-y-3 border-t border-gray-200 pt-4 bg-white/98 backdrop-blur-md relative z-[100] shadow-lg">
                <button onClick={goToHome} className="block w-full text-left py-2 text-gray-900 hover:text-[#059669] transition-colors font-medium hover:bg-gray-50 px-2 rounded-lg">
                  Ana Sayfa
                </button>

                {/* Hizmetler - Mobil Collapsible */}
                <Collapsible>
                  <CollapsibleTrigger className="flex items-center justify-between w-full text-left py-2 text-gray-900 hover:text-[#059669] transition-colors font-medium hover:bg-gray-50 px-2 rounded-lg">
                    Hizmetler
                    <ChevronDown className="w-4 h-4" />
                  </CollapsibleTrigger>
                  <CollapsibleContent className="pl-4 mt-2 space-y-2">
                    <button onClick={() => scrollToSection("google-partner")} className="block w-full text-left py-2 text-sm text-gray-700 hover:text-[#059669] transition-colors hover:bg-gray-50 px-2 rounded-lg">
                      🏆 Google Partner
                    </button>
                    <button onClick={() => scrollToSection("sahte-tiklama")} className="block w-full text-left py-2 text-sm text-gray-700 hover:text-[#059669] transition-colors hover:bg-gray-50 px-2 rounded-lg">
                      🛡️ Sahte Tıklama Koruması
                    </button>
                    <button onClick={() => scrollToSection("paketler")} className="block w-full text-left py-2 text-sm text-gray-700 hover:text-[#059669] transition-colors hover:bg-gray-50 px-2 rounded-lg">
                      📦 Paketler
                    </button>
                  </CollapsibleContent>
                </Collapsible>

                <button onClick={() => scrollToSection("yorumlar")} className="block w-full text-left py-2 text-gray-900 hover:text-[#059669] transition-colors font-medium hover:bg-gray-50 px-2 rounded-lg">
                  Yorumlar
                </button>

                <button onClick={() => scrollToSection("sss")} className="block w-full text-left py-2 text-gray-900 hover:text-[#059669] transition-colors font-medium hover:bg-gray-50 px-2 rounded-lg">
                  SSS
                </button>

                <Link to="/hakkimda" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left py-2 text-gray-900 hover:text-[#059669] transition-colors font-medium hover:bg-gray-50 px-2 rounded-lg">
                  Hakkımda
                </Link>

                <Link to="/blog" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left py-2 text-gray-900 hover:text-[#059669] transition-colors font-medium hover:bg-gray-50 px-2 rounded-lg">
                  Blog
                </Link>

                <button onClick={() => scrollToSection("iletisim")} className="block w-full text-left py-2 text-gray-900 hover:text-[#059669] transition-colors font-medium hover:bg-gray-50 px-2 rounded-lg">
                  İletişim
                </button>

                {/* Mobile CTA */}
                <div className="flex flex-col gap-2 pt-3 border-t border-gray-200">
                  <a href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-4 py-2 bg-[#25D366] text-white rounded-lg font-medium glow-green">
                    <MessageCircle className="w-4 h-4" />
                    WhatsApp
                  </a>
                  <a href={`tel:${phoneNumber}`} className="flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg font-medium glow-red">
                    <Phone className="w-4 h-4" />
                    Hemen Ara
                  </a>
                </div>
              </div>
            </>}
        </div>
      </header>

      {/* Main Content */}
      <main>{children}</main>

      {/* Footer - Temiz & Düzenli Tasarım */}
      <footer id="iletisim" className="bg-gradient-to-br from-[#012f23] via-[#024238] to-[#059669] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-12">
          
          {/* Üst Kısım - Logo & Partner Badge */}
          

          {/* Ana İçerik - 3 Sütun Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-8">
            
            {/* 1. Sütun - İletişim Bilgileri */}
            <div>
              <h3 className="text-lg font-bold mb-4 text-[#FFD700] flex items-center gap-2">
                <Phone className="w-5 h-5" />
                İletişim Bilgileri
              </h3>
              
              <div className="space-y-3 text-sm text-gray-200">
                {/* Telefon */}
                <a href="tel:05326369115" className="flex items-start gap-3 p-3 bg-white/5 rounded-lg hover:bg-white/10 transition-all group">
                  <Phone className="w-5 h-5 flex-shrink-0 mt-0.5 text-[#FFD700] group-hover:scale-110 transition-transform" />
                  <div>
                    <div className="font-semibold text-white">Telefon</div>
                    <div className="text-gray-300">0532 636 91 15</div>
                  </div>
                </a>

                {/* Email */}
                <a href="mailto:info@reklam-uzmani.com.tr" className="flex items-start gap-3 p-3 bg-white/5 rounded-lg hover:bg-white/10 transition-all group">
                  <MessageCircle className="w-5 h-5 flex-shrink-0 mt-0.5 text-[#FFD700] group-hover:scale-110 transition-transform" />
                  <div>
                    <div className="font-semibold text-white">E-posta</div>
                    <div className="text-gray-300 break-all">info@reklam-uzmani.com.tr</div>
                  </div>
                </a>

                {/* Adres */}
                <div className="flex items-start gap-3 p-3 bg-white/5 rounded-lg">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5 text-[#FFD700]" />
                  <div>
                    <div className="font-semibold text-white mb-1">Adres</div>
                    <div className="text-gray-300 leading-relaxed">
                      Adnan Kahveci, Yavuz Sultan Selim Blv. uyum çarşı içi kat 1 iç kapı no 72, 34528 Beylikdüzü/İstanbul
                    </div>
                  </div>
                </div>

                {/* Ücretsiz Görüşme Badge */}
                <div className="bg-[#FFD700]/20 rounded-lg p-3 border-2 border-[#FFD700]/50 mt-4">
                  <p className="text-sm font-bold text-white flex items-center gap-2">
                    <span className="text-lg">⏱️</span>
                    15 Dakika Ücretsiz Ön Görüşme
                  </p>
                </div>
              </div>
            </div>

            {/* 2. Sütun - Hızlı Bağlantılar */}
            <div>
              <h3 className="text-lg font-bold mb-4 text-[#FFD700]">
                Hızlı Bağlantılar
              </h3>
              <ul className="space-y-2.5 text-sm text-gray-200">
                <li>
                  <button onClick={() => scrollToSection("hero")} className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> Ana Sayfa
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection("google-partner")} className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> Google Partner
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection("yorumlar")} className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> Yorumlar
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection("sahte-tiklama")} className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> Sahte Tıklama
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection("paketler")} className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> Paketler
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection("sss")} className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> SSS
                  </button>
                </li>
                <li>
                  <Link to="/google-reklamlari-yonetimi" className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2 font-semibold">
                    <span>★</span> Google Reklam Yönetimi
                  </Link>
                </li>
                <li>
                  <Link to="/tesisatci-web-sitesi" className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2 font-semibold">
                    <span>🔧</span> Tesisatçı Web Sitesi
                  </Link>
                </li>
                <li>
                  <Link to="/hakkimda" className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> Hakkımda
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> Blog
                  </Link>
                </li>
              </ul>
            </div>

            {/* 3. Sütun - Yasal & CTA */}
            <div>
              <h3 className="text-lg font-bold mb-4 text-[#FFD700]">
                Yasal
              </h3>
              <ul className="space-y-2.5 text-sm text-gray-200 mb-6">
                <li>
                  <Link to="/gizlilik-politikasi" rel="nofollow" className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> Gizlilik Politikası
                  </Link>
                </li>
                <li>
                  <Link to="/kvkk" rel="nofollow" className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> KVKK
                  </Link>
                </li>
                <li>
                  <Link to="/cerez-politikasi" rel="nofollow" className="hover:text-[#FFD700] transition-all hover:translate-x-1 inline-flex items-center gap-2">
                    <span>→</span> Çerez Politikası
                  </Link>
                </li>
              </ul>

              {/* Hızlı İletişim Butonları */}
              <div className="space-y-3">
                <a href="https://wa.me/905326369115?text=Merhaba%20Mustafa%20Bey%2C%20Google%20Ads%20reklamlar%C4%B1m%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum." target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#25D366] text-white rounded-xl font-bold hover:bg-[#20BA5A] transition-all hover:scale-105 shadow-lg">
                  <MessageCircle className="w-5 h-5" />
                  WhatsApp ile İletişim
                </a>
                <a href="tel:05326369115" className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/10 text-white rounded-xl font-bold hover:bg-white/20 transition-all hover:scale-105 border-2 border-white/30">
                  <Phone className="w-5 h-5" />
                  Hemen Ara
                </a>
              </div>
            </div>
          </div>

          {/* Alt Kısım - Copyright */}
          <div className="border-t border-white/20 pt-6 text-center">
            <p className="text-sm text-gray-300 font-medium">
              © 2025 Dijital Mustafa - Google Reklam Yönetimi. Tüm hakları saklıdır.
            </p>
            <p className="text-xs text-gray-400 mt-2">
              Google Reklam Yönetimi | Google Partner | Profesyonel Reklam Yönetimi
            </p>
          </div>
        </div>
      </footer>

      {/* Cookie Banner */}
      <CookieBanner />
    </div>;
};
export default Layout;